import envConfig from './envConfig';

/**
 * authentication configuration (MSAL).
 *
 * export {
 *   msalConfig, loginRequest
 * }
 */
export const msalConfig = {
  auth: {
    clientId: envConfig.auth.clientId,
    authority: `https://login.microsoftonline.com/${envConfig.auth.tenantId}`,
    redirectUri: envConfig.appBaseUrl,
    // postLogoutRedirectUri: "https://localhost:3001/logout",
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    secureCookies: true
  }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ['User.Read', 'profile', 'User.Read.All', 'openid', 'email']
};
